import { TableBody, TableCell, TableRow } from '@mui/material';
import {
  FooterCell,
  FooterContainer,
  StyledHeader,
  StyledRow,
  StyledTable,
  HeaderCell,
} from 'components/TableComponents/TableComponents';

import {
  numberToCurrencyString,
  numberToPercentageString,
} from 'further-ui/utils';
import { round, sumBy } from 'lodash';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { InvestorAllocationTotals } from '../../types';

type Props = {
  investorAllocationsTotals: Array<InvestorAllocationTotals>;
  currency: CurrencyCode;
};

const InvestorTable: React.FC<Props> = ({
  investorAllocationsTotals,
  currency,
}) => {
  return (
    <StyledTable
      hasBorderTopLeftRadius
      hasBorderBottomLeftRadius
      hasMinWidth={false}
    >
      <StyledHeader>
        <StyledRow>
          <HeaderCell>Investor</HeaderCell>
          <HeaderCell>% Allocation</HeaderCell>
          <HeaderCell>Received consideration</HeaderCell>
          <HeaderCell>Escrow consideration</HeaderCell>
          <HeaderCell>Earnout consideration</HeaderCell>
          <HeaderCell>Withholding tax</HeaderCell>
        </StyledRow>
      </StyledHeader>
      <TableBody>
        {investorAllocationsTotals.map((investorAllocation) => (
          <StyledRow key={investorAllocation.commitmentId}>
            <TableCell>{investorAllocation.investorName}</TableCell>
            <TableCell>
              {numberToPercentageString(
                investorAllocation.averageAllocationPercentage,
                {
                  accuracy: 2,
                  noMultiply: true,
                },
              )}
            </TableCell>
            <TableCell>
              {numberToCurrencyString(
                investorAllocation.receivedConsideration,
                {
                  currency,
                },
              )}
            </TableCell>
            <TableCell>
              {numberToCurrencyString(investorAllocation.escrowConsideration, {
                currency,
              })}
            </TableCell>
            <TableCell>
              {numberToCurrencyString(investorAllocation.earnoutConsideration, {
                currency,
              })}
            </TableCell>
            <TableCell>
              {numberToCurrencyString(
                investorAllocation.withholdingTaxPayable,
                {
                  currency,
                },
              )}
            </TableCell>
          </StyledRow>
        ))}
      </TableBody>
      <FooterContainer>
        <TableRow>
          <FooterCell colSpan={1} paddingSize="sm"></FooterCell>
          <FooterCell colSpan={1} paddingSize="sm"></FooterCell>
          <FooterCell colSpan={1} paddingSize="sm">
            {numberToCurrencyString(
              round(
                sumBy(investorAllocationsTotals, 'receivedConsideration'),
                2,
              ),
            )}
          </FooterCell>
          <FooterCell colSpan={1} paddingSize="sm">
            {numberToCurrencyString(
              round(sumBy(investorAllocationsTotals, 'escrowConsideration'), 2),
            )}
          </FooterCell>
          <FooterCell colSpan={1} paddingSize="sm">
            {numberToCurrencyString(
              round(
                sumBy(investorAllocationsTotals, 'earnoutConsideration'),
                2,
              ),
            )}
          </FooterCell>
          <FooterCell colSpan={1} paddingSize="sm">
            {numberToCurrencyString(
              round(
                sumBy(investorAllocationsTotals, 'withholdingTaxPayable'),
                2,
              ),
            )}
          </FooterCell>
        </TableRow>
      </FooterContainer>
    </StyledTable>
  );
};

export default InvestorTable;
